<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item  prop="productId" v-if="adminShow">
        <el-input v-model="queryParams.productId" clearable placeholder="套餐序号"></el-input>
      </el-form-item>
      <el-form-item  prop="productName">
        <el-input v-model="queryParams.productName" clearable placeholder="名称"></el-input>
      </el-form-item>
      <el-form-item prop="operationId">
        <el-select v-model="queryParams.operationId" filterable clearable placeholder="运营商" @change="search">
          <el-option v-for="item in optOperatorList" :key="item.id" :label="item.operatorName" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item  prop="productType">
        <el-select v-model="queryParams.productType" filterable clearable placeholder="类型" @change="search">
          <el-option v-for="item in optType" :key="item.key" :label="item.value" :value="item.key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item  prop="unlimitedQuantity">
        <el-select v-model="queryParams.unlimitedQuantity" filterable clearable placeholder="是否畅享" @change="search">
          <el-option label="是" value="1"></el-option>
          <el-option label="否" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item  prop="status">
        <el-select v-model="queryParams.status" filterable clearable placeholder="是否启用" @change="search">
          <el-option label="是" value="1"></el-option>
          <el-option label="否" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item  prop="limitSpeed" v-if="checkPermi(['product:limitSpeed:show'])">
        <el-select v-model="queryParams.limitSpeed" filterable clearable placeholder="是否限速" @change="search">
          <el-option label="是" value="1"></el-option>
          <el-option label="否" value="0"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item  prop="productRuleId" v-if="checkPermi(['product:limitSpeedValue:show'])">
        <el-select v-model="queryParams.productRuleId" filterable clearable placeholder="限速值" @change="search">
          <el-option
            v-for="item in speedRuleData"
            :key="item.id"
            :label="item.name+' ' + item.speedValue"
            :value="item.id">
            <span style="float: left">{{ item.name }} <em style="color:red;font-weight:700">限速 {{ item.speedValue }}</em></span>
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" icon="el-icon-search"  @click="search">搜索</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
        <el-button type="primary" icon="el-icon-plus" @click="handleCreate" v-hasPermi="['product:add']">添加</el-button>
      </el-form-item>
    </el-form>
    <div class="table">
      <el-table :data="tableData" border id="out-table">
        <el-table-column prop="ids" label="序号" align="center" width="60px"></el-table-column>
        <el-table-column prop="productName" label="名称" align="center" min-width="160">
          <template slot-scope="{row}">
            <el-link v-if="checkPermi(['product:agent:list'])" type="primary" :underline="false" @click="handleShowAgent(row)">{{row.productName}}</el-link>
            <span v-else>{{row.productName}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="productType" label="类型" align="center"></el-table-column>
        <el-table-column prop="type" label="分类" align="center"></el-table-column>
        <el-table-column prop="flowInfo" label="资费信息" align="center" min-width="100">
          <template slot-scope="{row}">
            <el-tag v-for="(item,index) in row.flowInfo" :key="index" style="margin: 3px;">{{item}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="flowCount" label="流量" align="center"></el-table-column>
        <el-table-column prop="showFlowCount" label="展示流量" align="center" v-if="adminShow"></el-table-column>
        <el-table-column prop="total" label="短信数量" align="center"></el-table-column>
        <el-table-column prop="validityTime" label="有效期（天）" align="center" min-width="100"></el-table-column>
        <el-table-column prop="products" label="运营商价格" align="center" min-width="180">
          <template slot-scope="{row}">
            <div style="width:90px;display: inline-block;text-align: center;">
              <p v-for="(item,index) in row.products" :key="index">
                {{item.operatorName}}：
              </p>
            </div>
            <div style="width:60px;display: inline-block;">
              <p v-for="(item,index) in row.products" :key="index">
                {{item.currencySymbal}}{{item.price}}
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="products" label="加价价格" align="center" min-width="200" v-if="checkPermi(['product:add:price'])">
          <template slot-scope="{row}">
            <div style="width:90px;display: inline-block;text-align: center;">
              <p v-for="(item,index) in row.products" :key="index">
                {{item.operatorName}}：
              </p>
            </div>
            <div style="width:70px;display: inline-block;">
              <p v-for="(item,index) in row.products" :key="index">
                {{item.currencySymbal}}{{!item.extraPrice?0 : item.extraPrice}}
              </p>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="showPrice" label="市场价格" align="center"></el-table-column> -->
        <el-table-column prop="status" label="状态" align="center">
          <template slot-scope="{row}">
            <el-tag>{{row.status}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="限速套餐" align="center" width="200px" v-if="checkPermi(['product:limitSpeed'])">
          <template slot-scope="{row}" >
            <div v-if="row.limitSpeed === 1">
              <p>
                <el-button type="text" disabled>限速 {{row.limitSpeedValue}}</el-button>
                <el-button type="text" v-hasPermi="['product:edit:productSpeed']" @click="handleEditProductSpeed(row)"><i class="el-icon-edit"></i></el-button>
                <el-button type="text" v-hasPermi="['product:del:productSpeed']" @click="deleteProductSpeed(row)"><i class="el-icon-delete"></i></el-button>
              </p>
              <p>赠送 {{row.giftProduct}}</p>
            </div>
            <div v-if="row.limitSpeed === 0">
              <el-button type="text" v-hasPermi="['product:del:productSpeed']" @click="handleAddProductSpeed(row)"><i class="el-icon-plus"></i></el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" min-width="100" fixed="right" v-if="checkPermi(['product:add:price','product:edit'])">
          <template slot-scope="{row}">
            <p v-hasPermi="['product:add']"><el-link icon="el-icon-document-copy"  type="primary" :underline="false" @click="handleCopy(row.id)">复制</el-link></p>
            <p v-hasPermi="['product:edit']"><el-link v-if="row.editable" type="primary" :underline="false"  icon="el-icon-edit"  @click="handleEdit(row.id)">编辑</el-link></p>
            <p v-hasPermi="['product:add:price']"><el-link type="success" :underline="false" icon="el-icon-plus"  @click="addPrice(row)">加价</el-link></p>
            <!-- <el-button size="mini" type="text" plain @click="handleCopy(row.id)" icon="el-icon-document-copy" v-hasPermi="['product:add']">复制</el-button> -->
            <!-- <el-button size="mini" type="text" v-if="row.editable" plain @click="handleEdit(row.id)" icon="el-icon-edit" v-hasPermi="['product:edit']">编辑</el-button> -->
            <!-- <el-button size="mini" type="text" plain @click="addPrice(row)" icon="el-icon-plus" v-hasPermi="['product:add:price']">加价</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="page"
      :limit.sync="pageSize"
      @pagination="queryInfo"
    />
    <!--  加价  -->
    <el-dialog :title="title" :visible.sync="open" width="800px" append-to-body :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" label-width="130px" :inline="false">
        <el-row>
          <el-col :span="24">
            <el-form-item>
              <el-descriptions title="运营商价格" direction="vertical" :column="3">
                <el-descriptions-item label="中国移动">
                  <el-tag size="small">{{operatorPrice.ydPrice}}</el-tag>
                </el-descriptions-item>
                <el-descriptions-item label="中国联通">
                  <el-tag size="small">{{operatorPrice.ltPrice}}</el-tag>
                </el-descriptions-item>
                <el-descriptions-item label="中国电信">
                  <el-tag size="small">{{operatorPrice.dxPrice}}</el-tag>
                </el-descriptions-item>
            </el-descriptions>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item  label="移动加价" prop="ydPrice">
              <el-input placeholder="移动加价" v-model.number="form.ydPrice" oninput="value=value.replace(/[^\d.]/g,'')" @input="addExtraPrice('ydCommission')">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-input placeholder="移动加价佣金" style="width: 100%;" disabled v-model="form.ydCommission">
              <template slot="prepend">实返金额</template>
            </el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item  label="联通加价" prop="ltPrice">
              <el-input placeholder="联通加价" v-model.number="form.ltPrice" @input="addExtraPrice('ltCommission')">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-input placeholder="联通加价佣金" style="width: 100%;" disabled v-model="form.ltCommission">
              <template slot="prepend">实返金额</template>
            </el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item  label="电信加价" prop="dxPrice">
              <el-input placeholder="电信加价" v-model.number="form.dxPrice" @input="addExtraPrice('dxCommission')">
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-input placeholder="电信加价佣金" style="width: 100%;" disabled v-model="form.dxCommission">
              <template slot="prepend">实返金额</template>
            </el-input>
          </el-col>
        </el-row>
         <el-row>
           <el-col :span="24">
             <el-form-item  label="加价费率">
                <el-input placeholder="加价费率" disabled v-model="form.extraPriceRate" style="width: 100%;">
                  <template slot="append">%</template>
                </el-input>
              </el-form-item>
           </el-col>
         </el-row> 
          
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="speedTitle" :visible.sync="speedOpen" width="700px" append-to-body :close-on-click-modal="false">
      <el-form ref="productSpeedForm" :model="productSpeedForm" label-width="80px">
          <el-form-item  label="限速规则" prop="productRuleId">
            <el-select v-model="productSpeedForm.productRuleId"  placeholder="请选择限速规则" style="width:100%">
              <el-option
                v-for="item in speedRuleData"
                :key="item.id"
                :label="item.name+' ' + item.speedValue"
                :value="item.id">
                <span style="float: left">{{ item.name }} <em style="color:red;font-weight:700">限速 {{ item.speedValue }}</em></span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{!!item.freeProductName?'限速取消赠送':'无'}} {{ item.freeProductName }}</span>
              </el-option>
            </el-select>
          </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="productSpeedSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="agentTitle" :visible.sync="agentOpen" width="1200px" append-to-body destroy-on-close :close-on-click-modal="false">
      <el-row :gutter="10">
        <el-col :span="10">
          <el-input v-model="agentSearch" placeholder="请输入ID/账号/公司/分成模式/等级" clearable></el-input>
        </el-col>
      </el-row>
      <el-table :data="filteredAgentData" :height="`calc(100vh - 300px)`" border>
        <el-table-column prop="agentName" label="ID/账号/公司" align="center" min-width="160">
          <template slot-scope="{row}">
            [{{row.id}}]-[{{row.username}}]-<span style="color:#409eff">{{row.company}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="commissionModel" label="分成模式/等级" align="center" min-width="80">
          <template slot-scope="{row}">
            <el-tag>{{row.commissionModel}}</el-tag>
            <el-tag type="success" style="margin-left: 5px;">{{row.level}}</el-tag>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import {
  productPage,
  productType,
  addProductExtraPrice,
  productExtraPriceRate,
  listSpeedRule,
  updateProductSpeedRule,
  delProductSpeedRule,
  selectAgentByProduct
} from "@/api/api.js"; //套餐列表
import {operatorList} from "@/api/international.js";
export default {
  name: "packagelist",
  data() {
    var checkPrice = (rule, value, callback) => {
        if (!value && value!=0) {
          return callback(new Error('加价不能为空，可以为0'));
        }
        callback();
    }
    return {
      // 查询条件
      queryParams: {
        productName:undefined,
        operationId:undefined,
        productType:undefined,
        type:undefined,
        countryId:undefined,
        limitSpeed:undefined,
        productRuleId:undefined,
        unlimitedQuantity:undefined
      },
      optOperatorList:[],
      optType: [],
      isDisable: [
        { value: 0, label: "已禁用" },
        { value: 1, label: "启用中" }
      ],
      // 分页器
      page: 1,
      pageSize: 20,
      total: 20,
      // 列表数据
      tableData: [],
      open:false,
      title:'套餐加价',
      operatorPrice:{},
      form:{
        ydPrice:0,
        ydCommission:0,
        ltPrice:0,
        ltCommission:0,
        dxPrice:0,
        dxCommission:0,
        extraPriceRate:0,
      },
      rules:{
        ydPrice:[
            { validator: checkPrice, trigger: 'blur'}
        ],
        ltdPrice:[
            { validator: checkPrice, trigger: 'blur'}
        ],
        dxPrice:[
            { validator: checkPrice, trigger: 'blur'}
        ],
      },
      speedRuleData:[],
      speedTitle:'套餐限速',
      speedOpen:false,
      productSpeedForm:{
        productRuleId:undefined,
        productId:undefined
      },
      agentData:[],
      agentOpen:false,
      agentTitle:'套餐绑定的代理商',
      agentSearch:'',
      filteredAgentData: [], 
    };
  },
  computed: {
    adminShow(){
      return this.$store.getters.user.userType =='1'
    }
  },
  watch: {
    $route: {
      handler: function(to, from){
        if(to.name == 'packagelist'){
          this.queryInfo();
        }
      },
      // 深度观察监听
      deep: true
    }
  },
  methods: {
    // 类型转换
    transferPostageType(status) {
      let obj = {
        1: "累计套餐",
        2: "月套餐",
        3: "加油包",
        4: "停机保号"
      };
      return obj[status];
    },
    // 状态转换
    transferIsDisable(status) {
      let obj = {
        0: "未启用",
        1: "启用中"
      };
      return obj[status];
    },
    // 资费信息转换
    transferFlowRatio(status) {
      let obj = {
        1: "推荐",
        2: "基础资费",
        3: "仅续费充值",
        4: "限速套餐",
        5: "加速包",
        6: "月末折扣"
      };
      return obj[status];
    },
    //国家运营商列表
    selectOperatorList(){
      operatorList({type:'1'}).then(res =>{
        this.optOperatorList = res.data.data;
      })
    },
    //套餐类型列表
    productTypeList(){
      productType().then(res =>{
        if(res.data.code == 200){
            this.optType = res.data.data;
        }
      })   
    },
    // 获取列表
    queryInfo() {
      let params = {
        model:{
          ...this.queryParams,
        },
        page: this.page,
        pageSize: this.pageSize,
      };
      productPage(params).then(res => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
          this.tableData.map((item,index) => {
            item.flowCount = this.formatFlow(item.flowCount);
            item.showFlowCount = this.formatFlow(item.showFlowCount);
            if(this.adminShow){
              item.ids = item.id;
            }else{
              item.ids = index + 1;
            };
            item.status = this.transferIsDisable(item.status);
          })
        }else{
          this.$message.error(res.data.message);
        }
      });
    },
    formatFlow(flow){
      if(!flow){
        return null;
      }
      if(0 > flow){
        flow = "畅享";
      }else if(1024 > flow > 0){
        flow = flow + 'M';
      }else if(flow >= 1024){
        flow = (flow/1024).toFixed(2) + 'G';
      }
      return flow;
    },
    // 添加
    handleCreate() {
      this.$router.push({ path: `/package/add` });
    },
    // 编辑
    handleEdit(id) {
      this.$router.push({ path: `/package/edit/`+id });
      // this.$router.push({path:"/package/edit",query:{id: id}});
    },
    handleCopy(id) {
      this.$router.push({ path: `/package/copy/`+id });
      // this.$router.push({path:"/package/edit",query:{id: id}});
    },
    // 重置
    resetQuery() {
      this.resetForm("queryForm");
      this.queryInfo();
    },
    // 搜索
    search() {
      this.page = 1;
      this.queryInfo();
    },
    //套餐加价费率
    addPrice(row){
      productExtraPriceRate().then(res=>{
        if(res.data.code == 200){
            this.form.extraPriceRate = Number(!res.data.data.extraPriceRate ? 0 : res.data.data.extraPriceRate);
        }
        this.open = true;
        let operatorPrices = row.cardSource;
        this.form.productId = row.id
        operatorPrices.forEach(item=>{
          if(item.cardSourceName == '中国电信'){
            this.operatorPrice.dxPrice = item.price;
            this.form.dxPrice = !item.extraPrice? 0 : item.extraPrice;
            this.form.dxCommission = this.form.dxPrice - this.form.dxPrice * (this.form.extraPriceRate/100);
          }
          if(item.cardSourceName == '中国移动'){
            this.operatorPrice.ydPrice = item.price;
            this.form.ydPrice = !item.extraPrice? 0 : item.extraPrice;
            this.form.ydCommission = this.form.ydPrice - this.form.ydPrice * this.form.extraPriceRate/100;
          }
          if(item.cardSourceName == '中国联通'){
            this.operatorPrice.ltPrice = item.price;
            this.form.ltPrice = !item.extraPrice? 0 : item.extraPrice;
            this.form.ltCommission = this.form.ltPrice - this.form.ltPrice * this.form.extraPriceRate/100;
          }
        });
      })
      
    },
    //提交套餐加价
    submitForm(){
      this.$refs["form"].validate(valid => {
        if (valid) {
          addProductExtraPrice(this.form).then(res => {
            this.$message.success("套餐加价成功");
            this.open = false;
            this.resetQuery();
          });
        }
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.resetForm("form");
    },
    addExtraPrice(key){
      if(key == 'ydCommission'){
          this.form.ydCommission = Number(this.form.ydPrice) - Number(this.form.ydPrice) * Number(this.form.extraPriceRate)/100
      }
      if(key == 'ltCommission'){
          this.form.ltCommission = Number(this.form.ltPrice) - Number(this.form.ltPrice) * Number(this.form.extraPriceRate)/100
      }
      if(key == 'dxCommission'){
          this.form.dxCommission = Number(this.form.dxPrice) - Number(this.form.dxPrice) * Number(this.form.extraPriceRate)/100
      }
    },
    selectSpeedRules(){
      if(this.adminShow){
        listSpeedRule().then(res=>{
          this.speedRuleData = res.data.data
        })
      }
    },
    handleEditProductSpeed(row){
      this.speedOpen = true
      this.productSpeedForm.productId = row.id
      this.productSpeedForm.productRuleId = row.productRuleId
    },
    handleAddProductSpeed(row){
      this.speedOpen = true
      this.productSpeedForm.productId = row.id
      this.productSpeedForm.productRuleId = undefined
    },
    deleteProductSpeed(row){
      this.$confirm('是否确认将【'+row.productName+'】套餐的限速值移除，移除后将影响充值此套餐的所有卡？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            delProductSpeedRule({productId:row.id}).then(res=>{
                this.$message({type: 'success',message: '删除成功'});
                this.queryInfo();
            })
        })
    },
    productSpeedSubmit(){
      updateProductSpeedRule(this.productSpeedForm).then(res=>{
          this.productSpeedForm.productId = undefined
          this.productSpeedForm.productRuleId = undefined
          this.$message.success("套餐限速设置成功");
          this.queryInfo()
          this.speedOpen = false
      })
    },
    getCommissionModelText(model) {
      const modelMap = {
        0: "比例模式",
        1: "底价模式",
        2: "流量池模式"
      };
      return modelMap[model] || "";
    },
    //查看套餐绑定的代理商
    handleShowAgent(row){
      this.agentTitle = '['+row.id+']'+row.productName
      this.agentOpen = true
      selectAgentByProduct({productId:row.id}).then(res=>{
        if(res.data.code == 200){
          this.agentData = res.data.data.map(item=>{
            item.commissionModel = this.getCommissionModelText(item.commissionModel)
            item.level = item.level+'级'
            return item
          })
          // 初始化过滤数据
          this.filteredAgentData = [...this.agentData];
        }
      })
    },
    filterAgentData(keyword) {
      if (!keyword) {
        // 如果搜索关键词为空，显示全部数据
        this.filteredAgentData = [...this.agentData];
        return;
      }
      const lowerKeyword = keyword.toLowerCase();
      // 过滤数据，匹配ID/账号/公司/分成模式/等级
      this.filteredAgentData = this.agentData.filter(item => {
        return (
          item.id.toString().includes(lowerKeyword) ||
          (item.username && item.username.toLowerCase().includes(lowerKeyword)) ||
          (item.company && item.company.toLowerCase().includes(lowerKeyword)) ||
          (item.commissionModel.toLowerCase().includes(lowerKeyword)) ||
          item.level.includes(lowerKeyword)
        );
      });
    },
  },
  watch: {
    // 监听搜索关键词变化，实时过滤数据
    agentSearch(val) {
      this.filterAgentData(val);
    }
  },
  created() {
    this.productTypeList();
    this.queryInfo();
    this.selectOperatorList();
    this.selectSpeedRules()
  }
};
</script>
<style scoped lang="less">

</style>